module.exports = __webpack_public_path__ + "static/media/je.0ee90838.jpeg";